// Add type definitions for MenuItem and Page
export interface MenuItem {
  title: string;
  path: string;
  external?: boolean;
}

export interface Page {
  id: number;
  title: { rendered: string };
  content: { rendered: string };
  slug: string;
  [key: string]: any;
}

export const getApiBaseUrl = (): string => {
  // If VITE_API_BASE_URL is set in .env, use it
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  // Otherwise, determine based on current environment
  const isDev = import.meta.env.DEV;
  const {protocol} = window.location;
  const {hostname} = window.location;
  const port = isDev ? ':3000' : ''; // Use port 3000 in development

  return `${protocol}//${hostname}${port}/api`;
};

export const parseMenuConfig = (): MenuItem[] => {
  const menuConfig = import.meta.env.VITE_MENU_CONFIG || '';

  if (!menuConfig.trim()) {
    return [];
  }
  
  return menuConfig.split(',')
    .filter((item: string) => item.trim()) // Remove empty items
    .map((item: string) => {
      const parts = item.trim().split('|');
      if (parts.length !== 2) {
        console.warn(`Invalid menu item format: ${item}`);
        return null;
      }
      
      const [label, path] = parts;
      return {
        title: label.trim(),
        path: path.trim(),
        external: path.startsWith('http')
      };
    })
    .filter((item: MenuItem | null): item is MenuItem => item !== null); // Remove invalid items
};

export const getDefaultHomePage = async (): Promise<string> => {
  try {
    const apiBaseUrl = getApiBaseUrl();
    const response = await fetch(`${apiBaseUrl}/v2/pages`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const pages: Page[] = await response.json();
    const homePage = pages.find(page => page.slug === 'home');
    
    // If home page exists in WordPress, use it as root
    if (homePage) {
      return '/';
    }
    
    // If no home page found in WordPress, use static Home component
    return '/home';
  } catch (error) {
    console.error('Error fetching default home page:', error);
    return '/home';
  }
}; 